import { Component, Input, OnInit, OnDestroy, Output, EventEmitter } from "@angular/core";
import { ColumnDefinition, ColumnSort } from "./datatable.component";
import { Subject, Observable, Subscription } from "rxjs";

export class TextFilterOption {
    public text: string;
    public value: string;
    public checked: boolean;
    public showSeparator: boolean = false;

    private stateChangedSource: Subject<boolean>;
    public readonly stateChanged: Observable<boolean>;

    constructor(text: string, value: string) {
        this.stateChangedSource = new Subject<boolean>();
        this.stateChanged = this.stateChangedSource.asObservable();
        this.text = text;
        this.value = value;
        this.checked = true;
    }

    public raiseStateChanged(value: boolean): void {
        this.checked = value;
        this.stateChangedSource.next(value);
    }
}

@Component({
    selector: "text-filter",
    templateUrl: "./textFilter.component.html",
    styleUrls: ["./textFilter.component.css"],
    standalone: false
})
export class TextFilterComponent implements OnInit, OnDestroy {
    @Input() public index: number;
    @Input() public columnDefinition: ColumnDefinition;
    @Input() public data: any[][];
    @Input() public lastColumn: boolean;
    @Output() public filterUpdated: EventEmitter<void> = new EventEmitter<void>();

    public options: TextFilterOption[] = [];
    private optionSubscriptions: Subscription[] = [];

    public ngOnInit(): void {
        let options: TextFilterOption[] = [];
        for (let row of this.data) {
            let optText: string = this.columnDefinition.getDataValue(row[this.index]);
            if (options.find(x => x.text == optText) == null) {
                let option = new TextFilterOption(optText, row[this.index]);
                let checkA: boolean = (this.columnDefinition.filterTerm != null && this.columnDefinition.filterTerm instanceof Array
                    && (this.columnDefinition.filterTerm.length == 0 || this.columnDefinition.filterTerm.find(x => this.columnDefinition.checkEquality(x, option.value)) != null));
                let checkB: boolean = (this.columnDefinition.filterTerm != null && this.columnDefinition.checkEquality(this.columnDefinition.filterTerm, option.value));
                let checkC: boolean = this.columnDefinition.filterTerm == null;
                option.checked = checkA || checkB || checkC;
                options.push(option);
            }
        }

        let allOption = new TextFilterOption("Todos", "");
        allOption.showSeparator = true;
        allOption.checked = options.filter(x => x.checked).length == options.length;
        let allOptionSubscription = allOption.stateChanged.subscribe((state) => {
            if (state) {
                options.forEach(x => x.checked = true);
                this.columnDefinition.filterTerm = null;
            } else {
                options.forEach(x => x.checked = false);
                this.columnDefinition.filterTerm = [];
            }
            this.filterUpdated.emit();
        });


        this.optionSubscriptions = [allOptionSubscription].concat(options.map(x => x.stateChanged.subscribe((state) => {
            let selectedOptionsFilter = options.filter(x => x.checked).map(x => x.value);
            allOption.checked = options.length == selectedOptionsFilter.length;
            this.columnDefinition.filterTerm = selectedOptionsFilter;
            this.filterUpdated.emit();
        })));

        this.options = [allOption].concat(options.sort((a, b) => this.columnDefinition.sortWithOrder(a.value, b.value, ColumnSort.Asc)));
    }

    public ngOnDestroy(): void {
        this.optionSubscriptions.forEach(x => x.unsubscribe());
        this.optionSubscriptions = [];
    }
}
